export const link = (tokens) => {
    const { semantic, component: { link }, } = tokens;
    return {
        MuiLink: {
            styleOverrides: {
                root: {
                    fontWeight: link.fontWeight.value,
                    color: link.color.value,
                    textDecoration: link.textDecoration.value,
                    "&.MuiTypography-billboard": {
                        fontWeight: semantic.fontWeight.light.value,
                    },
                    "&:hover": {
                        color: link.hover.color.value,
                        textDecoration: link.hover.textDecoration.value,
                    },
                    "&:active": {
                        color: link.active.color.value,
                    },
                    "&:focus, &.Mui-focusVisible": {
                        borderRadius: link.focus.borderRadius.value,
                        boxShadow: semantic.shadow.focus.value.stringValue,
                        outline: "none",
                    },
                },
            },
        },
    };
};
export default link;
//# sourceMappingURL=link.js.map